import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext({
  language: "en",
  setLanguage: () => {},
});

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");

  // Detect language from URL path on mount and when URL changes
  useEffect(() => {
    const detectLanguage = () => {
      if (typeof window !== "undefined") {
        const path = window.location.pathname;
        // Check if path starts with /es/
        if (path.startsWith("/es/") || path === "/es") {
          setLanguage("es");
        } else {
          setLanguage("en");
        }
      }
    };

    detectLanguage();

    // Listen for URL changes (for SPA navigation)
    window.addEventListener("popstate", detectLanguage);

    // Also check periodically for gatsby navigate changes
    const interval = setInterval(detectLanguage, 500);

    return () => {
      window.removeEventListener("popstate", detectLanguage);
      clearInterval(interval);
    };
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
